import { useState } from 'react';
import { Button, Check } from '../input';
import { ArgsTable } from './Args';
import { Modal, closeHook } from '../modal';
import { useGlobal } from '../../state';

export const RunAgainButton = ({ job, ...props }) => {
  const { fox } = useGlobal();
  const [loading, setLoading] = useState();
  const [isTestRun, setIsTestRun] = useState();

  const close = closeHook();

  const handleRun = async () => {
    setLoading(true);
    const params = { ...job.params };
    if (isTestRun) {
      params.maxVisits = 20;
      params.maxExtracts = 20;
    }

    console.log('Run again with params:', params);

    const again = await fox[job.method].detach(params);

    console.log('Run again gave:', again);

    setLoading(false);
    close.trigger();

    window.location.href = `/jobs/${again.id}`;
  };

  return (
    <div>
      <Modal title="Run again" close={close.signal}>
        <Button {...props}>Run Again</Button>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <div
            style={{
              width: 640,
              height: 200,
              overflow: 'hidden',
              overflowY: 'scroll',
              border: '1px solid #eee',
              borderRadius: 4,
            }}
          >
            <ArgsTable job={job} />
          </div>

          <div>
            <Check useSwitch size="sm" value={isTestRun} onChange={setIsTestRun}>
              Do a small test run (uses fewer credits)
            </Check>
          </div>

          <div style={{ display: 'flex', justifyContentx: 'flex-end' }}>
            <Button onClick={handleRun} loading={loading} style={{ width: 180 }}>
              Run
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
